import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  max-width: fit-content;
`;

export const CodeText = styled.span`
  font-family: monospace;
  font-size: 14px;
  color: #6B7280;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 300px;
  font-family: Barlow, "Segoe UI", Roboto, monospace;
  cursor: pointer;
  &:hover {
    background-color: #f3f4f6;
    border-radius: 5px;
  }
`;

export const CopyButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px;
  color: #666;
  transition: color 0.2s;

  &:hover {
    color: #333;
  }

  &:active {
    transform: scale(0.95);
  }
`;
